// This file is AUTOGENERATED, do not edit it manually!!!

export const messageBoard = {
    add_message_button: 'Agregar mensaje',
    AdditionalRecipients: 'Destinatarios adicionales',
    Ai_disabled_button: 'Empieza a escribir para activar los comandos de IA',
    Append: 'Agregar',
    Apply: 'Aplicar',
    approval_request_approved_comment: 'aprobado con un mensaje',
    approval_request_link: 'solicitud de aprobación',
    approval_request_reject_comment: 'rechazado con un mensaje',
    Approve: 'Aprobar',
    Approver_Approved: 'aprobado',
    Approver_HasNotSeen: 'no leído',
    Approver_NoAction: 'sin acción',
    Approver_NotApproved: 'visto, aprobación pendiente',
    Approver_Rejected: 'rechazado',
    ApproversGroupTitle: 'Aprobadores',
    Attachment_Delete: 'El archivo \'{0}\' ha sido eliminado.',
    BaseNotificationRule: 'Basado en la regla de notificación',
    BeforePageUnloadMessage: 'Tus cambios se perderán. ¿Quieres salir de esta página sin guardar los cambios?',
    Cancel: 'Cancelar',
    ChangeTone: 'Cambiar el tono',
    Close: 'Cerrar',
    ContactAdministrator: 'Por favor, contacta a tu administrador',
    ContinueWriting: 'Continuar escribiendo con IA',
    Delete: 'Eliminar',
    DeleteAttachmentContentTemplate: '¿Estás seguro de que deseas eliminar el archivo adjunto \'{0}\' ?',
    DeleteAttachmentTitle: 'Eliminar archivo adjunto',
    Discard: 'Descartar',
    Download: 'Descargar',
    DropHere: 'Suelta los archivos aquí',
    Edit: 'Editar',
    edit_actions: 'Presiona ctrl + enter para <a apply>Aplicar</a> o esc para <a>Cancelar</a>',
    email_only_mention_title: 'Este usuario solo será notificado por correo electrónico',
    Error: 'Error',
    FilePlural: '1#{0} archivo#{0} archivos',
    FileUploadError: 'Error',
    FileVersion: 'Versión ',
    FileVersionShort: 'ver ',
    Formal: 'Formal',
    FreeSpaceTemplate: 'Has usado {0} MB de {1} MB.',
    Friendly: 'Amistoso',
    GeneratedByAi: 'Generado por IA...',
    HideFiles: 'Ocultar archivos',
    ImproveSpelling: 'Mejorar ortografía y gramática',
    ImproveWriting: 'Mejorar escritura',
    mention_title: 'Menciona a alguien',
    Message_Delete: 'El mensaje ha sido eliminado.',
    message_maxLength_description: 'Un mensaje puede contener hasta 10 000 caracteres.',
    message_maxLength_title: 'El mensaje es demasiado largo',
    MessageDeleteConfirmation: '¿Eliminar esta publicación?',
    messageEdited: '(editado)',
    MessageEditedBy: 'Editado por ',
    messagePlaceholderText: 'Agrega un mensaje, suelta archivos o @menciona a alguien',
    MultipleApproversTemplate: '{0} de {1} {2}',
    MyComputer: 'Mi computadora',
    NewMessageWatermark: 'Escribe un mensaje o suelta archivos...',
    NewPost: '1#{0} nueva publicación#{0} nuevas publicaciones',
    No: 'No',
    NoMatchRecipients: 'Miembro no encontrado',
    NoPermissionToEditMessage: 'Lo siento, no tienes permiso para editar este mensaje',
    Notification: 'Notificación',
    Notify: 'Notificar',
    NotifyLabel: 'Notificar...',
    NotProjectMembers: 'No miembros del proyecto',
    OneDrive: 'OneDrive',
    OneDriveFilePicker: 'Selector de archivos de OneDrive',
    Optimistic: 'Optimista',
    Or: 'o',
    PluralApproved: '1#aprobado#aprobados',
    PluralRejected: '1#{0} rechazado#{0} rechazados',
    Post: 'Publicar',
    PostWatingForApproval: 'La publicación está esperando aprobación',
    PreviewImages: 'Vista previa de imágenes',
    Professional: 'Profesional',
    ProjectMembers: 'Miembros del proyecto',
    Reject: 'Rechazar',
    Replace: 'Reemplazar',
    RequestApprovalLabel: 'Solicitar aprobación',
    Retry: 'Reintentar',
    SharePoint: 'SharePoint',
    SharePointFilePicker: 'Selector de archivos de SharePoint',
    ShowFiles: 'Mostrar archivos',
    ShowNext: 'Mostrar anterior',
    SingleApprovedTemplate: 'Aprobado por {0}',
    SingleApprovedTemplate_You: 'Aprobado por ti.',
    SingleApproverTemplate: 'Esperando aprobación de {0}',
    SingleRejectedTemplate: 'Rechazado por {0}',
    SingleRejectedTemplate_You: 'Rechazado por ti.',
    Straightforward: 'Directo',
    Summarize: 'Resumir',
    SummarizeBulletPoints: 'Resumir en viñetas',
    TabFiles: 'Archivos',
    TabMessages: 'Mensajes',
    Teams: 'Teams',
    Undo: 'Deshacer',
    UploadedBy: 'por ',
    Yes: 'Sí',
    You: 'Tú',
};
